import React, { useContext, useState } from "react";
import Select from "react-select";
import "./RegisterClient.css";
import TermsModal from "../Home/TermsModal/TermsModal";
import ClientInfo from "../Home/Clients/ClientInfo/ClientInfo";
import RequestRecords from "../Home/RequestRecords/RequestRecords";
import { BASE_URL } from "../../constants";
import { UserContext } from "../../context/UserContext";

const RegisterClient = ({ onBack }) => {
  const [step, setStep] = useState(1);
  const [role, setRole] = useState("");
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showUploadDocumentsCard, setshowUploadDocumentsCard] = useState(false);
  const [uploadedAuthorization, setUploadedAuthorization] = useState(null);
  const [uploadedID, setUploadedID] = useState(null);
  const [showSuccessCard, setshowSuccessCard] = useState(false);
  const [showClientInfo, setshowClientInfo] = useState(false);
  const [clientData, setClientData] = useState(null);
  const [showRequestRecords, setShowRequestRecords] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dob: "",
    fileNumber: "",
    injuryDate: "",
    country: "Canada",
    jurisdiction: "",
    healthCardNumber: "",
    phoneNumber: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    postalCode: "",
    groups: [], // array to hold selected groups
    sdmType: "",
    sdmFirstName: "",
    sdmMiddleName: "",
    sdmLastName: "",
    sdmRelationship: "",
    sdmEmail: "",
  });

  const {
    user: { lawyer_id },
  } = useContext(UserContext);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        role, // include client/substitute role from Step 1
      };

      console.log("Submitting client data:", payload);

      const response = await fetch(`${BASE_URL}/api/clients/${lawyer_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const text = await response.text(); // always get text first
      let result;

      try {
        result = JSON.parse(text);
      } catch (err) {
        console.error("Server did not return JSON:", text);
        alert("Server error: invalid response.");
        return;
      }

      console.log("Server JSON:", result);

      if (response.ok) {
        const client = result.client || null;
        console.log("New client created:", client);

        setClientData(client); // Store the newly created client data
        setStep(1);
        setRole("");
        setFormData({
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          fileNumber: "",
          injuryDate: "",
          country: "Canada",
          jurisdiction: "",
          healthCardNumber: "",
          phoneNumber: "",
          email: "",
          address1: "",
          address2: "",
          city: "",
          province: "",

          // SDM info
          sdmType: "",
          sdmFirstName: "",
          sdmMiddleName: "",
          sdmLastName: "",
          sdmRelationship: "",
          sdmEmail: "",
        });
      } else {
        console.error("Server returned error:", result);
        alert(result.error || "Error registering client.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("Could not reach server. Check your connection.");
    }
  };

  const handleModalSubmit = () => {
    setShowConfirmation(true);
    setTermsAccepted(true); // Mark terms as accepted when going back
  };

  const handleNext = () => {
    if (!role) {
      alert("Please select an option to proceed.");
      return;
    }

    if (role === "substitute") {
      setStep(2); // Go to substitute info
    } else {
      setStep(3); // Skip to client info
    }
  };

  const handleBackFromConfirmation = () => {
    setShowConfirmation(false);
  };

  const handleFileUpload = (e, type) => {
    const file = e.target.files[0];
    if (type === "authorization") {
      setUploadedAuthorization(file);
    } else {
      setUploadedID(file);
    }
  };

  const handleFinishLater = () => {
    handleSubmit();
    setshowUploadDocumentsCard(false);
    setshowSuccessCard(true);
  };

  const handleConfirmationNext = () => {
    setShowConfirmation(false);
    setshowUploadDocumentsCard(true);
  };

  const handleGoToClient = () => {
    setshowSuccessCard(false);
    setshowClientInfo(true);
  };

  if (showClientInfo) {
    return (
      <ClientInfo
        onBack={() => {
          setshowClientInfo(false);
          setShowRequestRecords(true);
        }}
        selectedClient={clientData}
      />
    );
  }

  if (showRequestRecords) {
    return (
      <RequestRecords
        onBack={() => {
          setShowRequestRecords(false);
          onBack();
        }}
      />
    );
  }

  return (
    <div className="register-page">
      {!showUploadDocumentsCard && !showSuccessCard && (
        <div className="top-header">
          <button onClick={onBack}>← Back to Clients List</button>
          <h1>Register Client</h1>
        </div>
      )}
      {step === 1 && !showSuccessCard && (
        <div className="form-card">
          <h2>Before we begin,</h2>
          <p>We need to know whose consents we're collecting.</p>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Select...</option>
            <option value="client">
              My client is signing their own consents
            </option>
            <option value="substitute">
              A Substitute Decision Maker is signing the consents
            </option>
          </select>
          <button className="next-btn" onClick={handleNext}>
            Next
          </button>
        </div>
      )}
      {step === 2 && role === "substitute" && (
        <div className="form-card">
          <h2>Substitute Decision Maker Information</h2>
          <p>We need to know who will be consenting on your client's behalf.</p>

          <label>SDM Type *</label>
          <select
            name="sdmType"
            value={formData.sdmType}
            onChange={handleChange}
          >
            <option value="">Select...</option>
            <option value="Parent or Guardian">Parent or Guardian</option>
            <option value="Power of Attorney">
              Power of Attorney/Litigation Guardian
            </option>
            <option value="Executor of Estate">Executor of Estate</option>
          </select>

          <label>First Name *</label>
          <input
            name="sdmFirstName"
            value={formData.sdmFirstName}
            onChange={handleChange}
          />

          <label>Middle Name</label>
          <input
            name="sdmMiddleName"
            value={formData.sdmMiddleName}
            onChange={handleChange}
          />

          <label>Last Name *</label>
          <input
            name="sdmLastName"
            value={formData.sdmLastName}
            onChange={handleChange}
          />

          <label>Relationship to Client *</label>
          <select
            name="sdmRelationship"
            value={formData.sdmRelationship}
            onChange={handleChange}
          >
            <option value="">Select...</option>
            <option value="Spouse">Spouse</option>
            <option value="Parent">Parent</option>
            <option value="Child">Child</option>
            <option value="Sibling">Sibling</option>
            <option value="Extended Family">Extended Family</option>
            <option value="Friend">Friend</option>
            <option value="Other">Other</option>
          </select>

          <label>Contact Email (used for e-signature)</label>
          <input
            type="email"
            name="sdmEmail"
            value={formData.sdmEmail}
            onChange={handleChange}
          />
          <button className="next-btn" onClick={() => setStep(3)}>
            Next
          </button>
        </div>
      )}
      {step === 3 &&
        !showConfirmation &&
        !showUploadDocumentsCard &&
        !showSuccessCard && (
          <div className="form-card">
            <h2>Client Information</h2>
            <p>
              Please input as shown on your client's health card or other
              identification. This is required for accurate and timely
              processing of your records.
              <br />
              There is a confirmation screen before you continue.
            </p>

            <label>First Name *</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />

            <label>Middle Name</label>
            <input
              name="middleName"
              value={formData.middleName}
              onChange={handleChange}
            />

            <label>Last Name *</label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />

            <label>Gender</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
            >
              <option value="">Select...</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>

            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
            />
            <div className="hint-box">
              Please ensure the DOB is correct as it is the primary information
              that providers use to verify your client.
            </div>

            <label>File #</label>
            <input
              name="fileNumber"
              value={formData.fileNumber}
              onChange={handleChange}
            />

            <label>Date of Injury/Loss</label>
            <input
              type="date"
              name="injuryDate"
              value={formData.injuryDate}
              onChange={handleChange}
            />

            <label>Country *</label>
            <input name="country" value="Canada" readOnly />

            <label>Canadian Health Card Jurisdiction *</label>
            <select
              name="jurisdiction"
              value={formData.jurisdiction}
              onChange={handleChange}
            >
              <option value="">Select...</option>
              <option value="ON">Ontario</option>
              <option value="BC">British Columbia</option>
              <option value="QC">Quebec</option>
              <option value="AB">Alberta</option>
              {/* Add more provinces as needed */}
            </select>

            <label>Canadian Health Card Number *</label>
            <input
              name="healthCardNumber"
              value={formData.healthCardNumber}
              onChange={handleChange}
            />

            <label>Phone Number *</label>
            <input
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
            />

            <label>Contact Email (used for e-signature)</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />

            <label>Address Line 1 *</label>
            <input
              name="address1"
              value={formData.address1}
              onChange={handleChange}
            />

            <label>Address Line 2</label>
            <input
              name="address2"
              value={formData.address2}
              onChange={handleChange}
            />

            <label>City *</label>
            <input name="city" value={formData.city} onChange={handleChange} />

            <label>Province *</label>
            <input
              name="province"
              value={formData.province}
              onChange={handleChange}
            />

            <label>Postal Code *</label>
            <input
              name="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
            />

            <label>Add client to Group</label>
            <p className="small-text">
              Select one or more Group(s) to add this new client to. Staff users
              in those Group(s) will automatically be subscribed to this new
              client.
            </p>
            <Select
              isMulti
              name="groups"
              options={[
                { value: "Group A", label: "Group A" },
                { value: "Group B", label: "Group B" },
                { value: "Group C", label: "Group C" },
              ]}
              className="basic-multi-select"
              classNamePrefix="select"
              value={formData.groups.map((g) => ({ value: g, label: g }))}
              onChange={(selectedOptions) =>
                setFormData((prev) => ({
                  ...prev,
                  groups: selectedOptions
                    ? selectedOptions.map((option) => option.value)
                    : [],
                }))
              }
            />
            {termsAccepted && (
              <div className="terms-accepted-banner">
                <span>Terms of Use Accepted ✔</span>
              </div>
            )}
            <div className="button-row">
              <button className="back-btn" onClick={() => setStep(step - 1)}>
                Back
              </button>
              <button
                className="next-btn"
                onClick={() =>
                  termsAccepted
                    ? setShowConfirmation(true)
                    : setShowTermsModal(true)
                }
              >
                Next
              </button>
            </div>
          </div>
        )}
      {showConfirmation && (
        <div className="confirmation-card">
          <h2>Confirm Client Information</h2>
          <p>Please take a moment to confirm the information.</p>

          <div className="confirmation-details">
            <div className="confirmation-row">
              <span className="confirmation-label">Name</span>
              <span className="confirmation-value">
                {formData.firstName} {formData.middleName} {formData.lastName}
              </span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">Date of Birth</span>
              <span className="confirmation-value">{formData.dob}</span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">
                Health Card Jurisdiction
              </span>
              <span className="confirmation-value">
                {formData.jurisdiction}
              </span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">Address</span>
              <span className="confirmation-value">
                {formData.address1}
                <br />
                {formData.city}, {formData.province}, {formData.postalCode}
              </span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">File #</span>
              <span className="confirmation-value">{formData.fileNumber}</span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">
                Canadian Health Card Number
              </span>
              <span className="confirmation-value">
                {formData.healthCardNumber}
              </span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">Phone Number</span>
              <span className="confirmation-value">{formData.phoneNumber}</span>
            </div>

            <div className="confirmation-row">
              <span className="confirmation-label">
                Contact Email (used for e-signature)
              </span>
              <span className="confirmation-value">
                {formData.email || "Not provided"}
              </span>
            </div>
          </div>

          <div className="confirmation-actions">
            <button className="back-btn" onClick={handleBackFromConfirmation}>
              Back
            </button>
            <button className="submit-btn" onClick={handleConfirmationNext}>
              Next
            </button>
          </div>
        </div>
      )}
      {showUploadDocumentsCard && (
        <div className="upload-documents-card">
          <h1>Upload Required Documents</h1>
          <p className="upload-description">
            To finish setting up your client's file on Nobel AI Legal, please
            upload the following Authorizations and Supporting Documents
            required to facilitate record requests. If you do not have these
            documents on hand, you may also request/upload them later in your
            client's Consent Manager page.
          </p>

          <div className="document-section">
            <h2>Authorization & Direction</h2>
            <p className="section-description">
              Invite your client to e-sign authorizations, or upload an image of
              your client's signed Nobel AI Legal authorization form here for
              verification.
            </p>
            <p className="form-requirements">
              Forms should only have the client and/or witness signature(s) on
              them; forms with other info written on them will be rejected.
            </p>

            <div className="upload-options">
              <button className="esign-btn">Request e-signature</button>
              <span className="or-divider">or</span>
              <div className="file-upload">
                <input
                  type="file"
                  id="authorization-upload"
                  onChange={(e) => handleFileUpload(e, "authorization")}
                  accept="image/*,.pdf"
                  hidden
                />
                <label htmlFor="authorization-upload" className="upload-label">
                  {uploadedAuthorization ? (
                    <span>{uploadedAuthorization.name}</span>
                  ) : (
                    <>
                      <span>Drop signed consent forms here, or </span>
                      <span className="click-to-choose">
                        click to choose files
                      </span>
                    </>
                  )}
                </label>
              </div>
            </div>
          </div>

          <div className="document-section">
            <h2>Scan of Photo Identification</h2>
            <p className="section-description">
              Client IDs are used by healthcare providers for patient
              verification and to speed up record retrieval.
            </p>

            <div className="upload-options">
              <div className="file-upload">
                <input
                  type="file"
                  id="id-upload"
                  onChange={(e) => handleFileUpload(e, "id")}
                  accept="image/*,.pdf"
                  hidden
                />
                <label htmlFor="id-upload" className="upload-label">
                  {uploadedID ? (
                    <span>{uploadedID.name}</span>
                  ) : (
                    <>
                      <span>Drop ID scan here, or </span>
                      <span className="click-to-choose">
                        click to choose files
                      </span>
                    </>
                  )}
                </label>
              </div>
            </div>
          </div>

          <div className="upload-actions">
            <button className="skip-btn" onClick={handleFinishLater}>
              Skip for now
            </button>
            <button
              className="finish-btn"
              disabled={!uploadedAuthorization || !uploadedID}
            >
              Upload & finish
            </button>
          </div>
        </div>
      )}
      {showTermsModal && (
        <TermsModal
          onAccept={() => {
            handleModalSubmit();
            setShowTermsModal(false);
          }}
          onCancel={() => setShowTermsModal(false)}
        />
      )}
      {showSuccessCard && (
        <div className="success-card">
          <div className="success-header">
            <h1>Client Registered!</h1>
            <div className="success-icon">✓</div>
          </div>

          <div className="success-content">
            <h2>What's next?</h2>
            <p>
              A new profile has been created for your client. Before you can
              begin requesting records, please go to your client's Consent
              Manager page to request/upload signed Nobel AI Legal
              authorizations.
            </p>
          </div>

          <div className="success-actions">
            <button className="client-btn" onClick={handleGoToClient}>
              Go to Client
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterClient;
